export const COLORS = [
  'blue',
  'green',
  'purple',
  'yellow',
  'red',
  'orange',
  'pink',
  'teal',
  'lavender',
  'gold',
  'coral'
]
export const CHART_COLORS = {
  blue: '#1D87C9',
  green: '#1DC8B4',
  purple: '#C81D87',
  yellow: '#FDC80D',
  red: '#E63946',
  orange: '#F77F00',
  pink: '#FF6EC7',
  teal: '#00A6A6',
  lavender: '#8075FF',
  gold: '#FFD700',
  coral: '#FF6F61'
}

export const CHART_COLORS_ALPHA_05 = {
  blue: '#1d87c980',
  green: '#1dc8b480',
  purple: '#c81d8780',
  yellow: '#fdc80d80',
  red: '#E6394680',
  orange: '#F77F0080',
  pink: '#FF6EC780',
  teal: '#00A6A680',
  lavender: '#8075FF80',
  gold: '#FFD70080',
  coral: '#FF6F6180'
}

export const CHART_COLORS_ALPHA_02 = {
  blue: '#1d87c933',
  green: '#1dc8b433',
  purple: '#c81d8733',
  yellow: '#fdc80d33',
  red: '#E6394633',
  orange: '#F77F0033',
  pink: '#FF6EC733',
  teal: '#00A6A633',
  lavender: '#8075FF33',
  gold: '#FFD70033',
  coral: '#FF6F6133'
}

export const CHART_COLORS_ALPHA_005 = {
  blue: '#1d87c90d',
  green: '#1dc8b40d',
  purple: '#c81d870d',
  yellow: '#fdc80d0d',
  red: '#E639460D',
  orange: '#F77F000D',
  pink: '#FF6EC70D',
  teal: '#00A6A60D',
  lavender: '#8075FF0D',
  gold: '#FFD7000D',
  coral: '#FF6F610D'
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/helpers/ChartColours.js